<template>
  <div class="select-mode">
    <span v-bind:class="{'ml-2': hebrew, 'mr-2': !hebrew}">{{hebrew ? 'אזכורים' : 'Mode'}}</span>
    <dicta-dropdown
        @change="val => browseOptions(modeChoices.indexOf(val))"
        :value="modeChoices[this.modeIndex]"
        :options="modeChoices"
        class="d-dropdown bg-white"
      ></dicta-dropdown>
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'
export default {
  name: 'SelectMode',
  data() {
    return {
      
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }, 
    modeChoices () {
      return this.hebrew ? ['תנ״ך, תלמוד ומשנה', 'תנ״ך בלבד' ,'תלמוד בלבד', 'משנה בלבד'] : ['Tanakh/Talmud/Mishnah', 'Tanakh', 'Talmud', 'Mishna']
    },   
    modeIndex:  {
      get: function () {
      return this.$store.state.mode+1
      },
    // setter
      set: function (newValue) {
      this.$store.commit('SET_MODE', newValue-1)
      }
    }
  },
  methods: {
    browseOptions(index) {
      if(index != this.modeIndex){
        this.modeIndex = index;  
        switch(index){
          case 0:
            this.$store.commit('SET_VISUALIZER_MODE', ['tanakh','talmud','mishna'])
            break;
          case 1:
            this.$store.commit('SET_VISUALIZER_MODE', ['tanakh'])
            break;
          case 2:
            this.$store.commit('SET_VISUALIZER_MODE', ['talmud'])
            break;
          case 3:
             this.$store.commit('SET_VISUALIZER_MODE', ['mishna'])
            break;      
        }
        
        this.$store.dispatch(Actions.RUN_PARSE) 
       
      }    
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .dropdown.btn-group{width: 217px;}
  .he .dropdown.btn-group{width:174px}

  @media only screen and (max-width: 959px) {
    .he .dropdown.btn-group{width:174px}
  }
</style>
